module.exports = __webpack_public_path__ + "static/media/icon-ticket.54edd682.svg";